import { render, staticRenderFns } from "./RequesterDetails.vue?vue&type=template&id=3602efae"
import script from "./RequesterDetails.vue?vue&type=script&lang=js"
export * from "./RequesterDetails.vue?vue&type=script&lang=js"
import style0 from "./RequesterDetails.vue?vue&type=style&index=0&id=3602efae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports